import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

//const GA_TRACKING_ID = 'G-3SVZFRJWGS';
const GA_TRACKING_ID = 'G-LP3HZLYR3Y';

function loadGtagScript() {
  if (!window.gtag) {
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_TRACKING_ID}', { send_page_view: false });
    `;
    document.head.appendChild(script2);
  }
}

export default function GoogleAnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    loadGtagScript();
  }, []);

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', GA_TRACKING_ID, {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null;
}
